export const getAppExtensionData = () => {
  return window.mainConfig?.appExtensionData || {};
};

export const getCurrentPageIdentifier = () => {
  return window.mainConfig?.pageIdentifier || '';
};

export const getCurrentThemeKey = () => {
  return window.mainConfig?.merchantData?.current_theme_key || '';
};

export const getLoadedLanguage = () => {
  return window.mainConfig?.localeData?.loadedLanguage || '';
};
